<template>
    <transition name="fade" v-if="checked">
        <div class="action-check">
            <div class="overlay"></div>
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
        </div>
    </transition>
</template>

<script>
import {writeTrackLog} from "../../utils/tracking";

export default {
  name: 'action-check',

  computed: {
    checked() {
      return this.$store.state.checked
    }
  },

  watch: {
    checked: function (val) {
      if (val) {
        if (this.$store.state.enableTracking) writeTrackLog("CHECKED");
        const self = this;

        window.setTimeout(function () {
          console.log('setTimeout', self.$store.state.afterChecked)
          if (self.$store.state.afterChecked !== null && self.$store.state.afterChecked !== undefined) {
            if (self.$store.state.afterChecked === -1) {
              self.$router.go(-1);
            } else {
              if (self.$store.state.afterChecked.name === 'pin') {
                self.$store.dispatch('clearCurrentEmployee');
              }
              self.$router.push(self.$store.state.afterChecked);
            }
          } else {
            self.$store.dispatch('clearCurrentEmployee');
            if (self.$route.name !== 'pin') self.$router.push({name: 'pin'});
          }

          self.$store.commit('clearChecked');
        }, 2000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .action-check {
        position: absolute;
        z-index: 20;
        width: 100vw;
        height: 100vh;
    }
    .action-check > .overlay {
        position: absolute;
        width: 100%;
        height: calc(100vh - 70px);
        bottom: 0;
        /*background: rgba(0,0,0,0.25);*/
        background: #f5f4f0;
    }

    $color--green: #7ac142;
    $curve: cubic-bezier(0.650, 0.000, 0.450, 1.000);

    .checkmark__circle {
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke: $color--green;
        fill: none;
        animation: stroke .6s $curve forwards;
    }

    .checkmark {
        position: absolute;
        left: calc(50vw - 56px);
        top: calc(50vh - 56px);
        width: 56px;
        height: 56px;
        border-radius: 50%;
        display: block;
        stroke-width: 2;
        stroke: #fff;
        stroke-miterlimit: 10;
        margin: 0 auto;
        box-shadow: inset 0px 0px 0px $color--green;
        animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
        z-index: 21;
    }

    .checkmark__check {
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        animation: stroke .3s $curve .8s forwards;
    }

    @keyframes stroke {
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes scale {
        0%, 100% {
            transform: none;
        }
        50% {
            transform: scale3d(1.1, 1.1, 1);
        }
    }

    @keyframes fill {
        100% {
            box-shadow: inset 0px 0px 0px 30px $color--green;
        }
    }
</style>
